const moment = require('moment');
class Tools {
  getSessionId(domainId) {
    return (
      this.getCookie(`session_id${domainId}`) ||
      window.localStorage.getItem(`session_id${domainId}`)
    );
  }

  getUserId(domainId) {
    return (
      this.getCookie(`cookie_id${domainId}`) ||
      window.localStorage.getItem(`cookie_id${domainId}`)
    );
  }

  getRingtone(domainId) {
    const ringtone =
      this.getCookie(`ringtone${domainId}`) ||
      window.localStorage.getItem(`ringtone${domainId}`) ||
      0;
    return Number(ringtone);
  }

  getMidLate(domainId) {
    return (
      this.getCookie(`mid_late${domainId}`) ||
      window.localStorage.getItem(`mid_late${domainId}`)
    );
  }

  getTypeProfile(domainId) {
    return (
      this.getCookie(`type_profile${domainId}`) ||
      window.localStorage.getItem(`type_profile${domainId}`)
    );
  }

  getGreeting(domainId) {
    const greeting =
      this.getCookie(`greeting${domainId}`) ||
      window.localStorage.getItem(`greeting${domainId}`) ||
      0;
    return Number(greeting);
  }

  setRingtone(domainId, val) {
    window.localStorage.setItem(`ringtone${domainId}`, val);
    this.setCookie(`ringtone${domainId}`, val, 30);
  }

  setGreeting(domainId) {
    window.localStorage.setItem(`greeting${domainId}`, 1);
    this.setCookie(`greeting${domainId}`, 1, 30);
  }

  setInfo(domainId) {
    window.localStorage.setItem(`info${domainId}`, true);
    this.setCookie(`info${domainId}`, true, 30);
  }

  setTypeProfile(domainId) {
    window.localStorage.setItem(`type_profile${domainId}`, 2);
    this.setCookie(`type_profile${domainId}`, 2, 30);
  }

  setMidLate(domainId, midLate) {
    window.localStorage.setItem(`mid_late${domainId}`, midLate);
    this.setCookie(`mid_late${domainId}`, midLate, 30);
  }

  setUserId(domainId, userId) {
    window.localStorage.setItem(`cookie_id${domainId}`, userId);
    this.setCookie(`cookie_id${domainId}`, userId, 30);
  }

  setSessionId(sessionId, domainId) {
    window.localStorage.setItem(`session_id${domainId}`, sessionId);
    this.setCookie(`session_id${domainId}`, sessionId, 30);
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 10 * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  deleteCookie(name) {
    document.cookie = name + '="";-1; path=/';
  }
  cutString(str) {
    return str.slice(0, str.indexOf('@'));
  }
  deleteAllCookies() {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf('=');
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
  }
  convertTime(time) {
    var date = new Date(time * 1000);
    // Hours part from the timestamp
    var hours = date.getHours();
    // Minutes part from the timestamp
    var minutes = '0' + date.getMinutes();
    var formattedTime = hours + ':' + minutes.substr(-2);
    return formattedTime;
  }

  getDate(timestamp) {
    try {
      const date = moment.unix(timestamp);
      const isCurrentDate = date.isSame(new Date(), 'day');
      if (isCurrentDate) {
        return 'Hôm nay';
      }
      return date.format('MM/DD/YYYY');
    } catch (e) {
      return '';
    }
  }

  getFavicon() {
    var favicon = undefined;
    var nodeList = document.getElementsByTagName('link');
    for (var i = 0; i < nodeList.length; i++) {
      if (
        nodeList[i].getAttribute('rel') == 'icon' ||
        nodeList[i].getAttribute('rel') == 'shortcut icon'
      ) {
        favicon = nodeList[i].getAttribute('href');
      }
    }
    return favicon;
  }

  addMessFaceBook(id, color, message) {
    const divRoot = document.createElement('div');
    const scriptFb = document.createElement('script');
    const divPage = document.createElement('div');
    divPage.className = 'fb-customerchat';
    divPage.setAttribute('attribution', 'setup_tool');
    divPage.setAttribute('page_id', id);
    divPage.setAttribute('logged_in_greeting', message);
    divPage.setAttribute('logged_out_greeting', message);
    divPage.setAttribute('theme_color', color);
    document.body.appendChild(divPage);
    divRoot.id = 'fb-root';
    scriptFb.innerHTML = `window.fbAsyncInit = function() {
          FB.init({
            xfbml            : true,
            version          : 'v8.0'
          });
        };
        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));`;
    document.body.appendChild(divRoot);
    document.head.appendChild(scriptFb);

    const style = document.createElement('style');
    style.innerHTML = `#fb-root { display: none;}`;
    document.head.appendChild(style);

    const scriptFc = document.createElement('script');
    scriptFc.innerHTML = `

      function showFBMessenger() {
        document.getElementById("fb-root").style.display = 'block';
        FB.CustomerChat.show(true);
        setTimeout(() => {FB.CustomerChat.show(true);}, 500);
        document.getElementById("mo-chat-frame").style.display = 'none';
        var element = document.getElementById("fb-root").getElementsByTagName("iframe")[0];
        var lastHeight = element.style.maxHeight, newHeight;
        (function run() {
          newHeight = element.style.maxHeight;
          if (lastHeight != newHeight) {
            if (newHeight === "0px") {
              document.getElementById("fb-root").style.display = 'none';
              document.getElementById("mo-chat-frame").style.display = 'block';
            }
          }
          lastHeight = newHeight
          if (element.onElementHeightChangeTimer)
            clearTimeout(element.onElementHeightChangeTimer)
          element.onElementHeightChangeTimer = setTimeout(run, 100)
        })()
      }
      function showFB() {
        document.getElementById("fb-root").style.display = 'block';
        FB.CustomerChat.show(true);
        setTimeout(() => {FB.CustomerChat.show(true);}, 500);
      }`;
    document.head.appendChild(scriptFc);
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  message(txt) {
    return txt.replace(/\n/g, '<br/>');
  }

  nameFile(txt) {
    return txt.replace(/ /g, '_');
  }

  validatePhone(phone) {
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(phone);
  }

  validateLink(txt) {
    const re = /(https?:\/\/[^\s]+)/g;
    return re.test(txt);
  }

  validateAudio(txt) {
    const re = /(\.mp3)$/i;
    return re.test(txt);
  }

  updateConfig(config, response) {
    // console.log('dsdsd', response.properties.widget_properties);
    const properties = response.properties;
    config.properties = response.properties;
    config.displayChat = false;
    config.merchant_id = response.merchant_id;

    config.width = properties.chat_tool_properties.config_frame.width;
    config.height = properties.chat_tool_properties.config_frame.height;

    config.time_popup = parseInt(
      properties.chat_tool_properties.greeting_setting.time_popup
    );
    config.isShowGreeting =
      properties.chat_tool_properties.greeting_setting.popup_message_on;
    config.header_color =
      properties.chat_tool_properties.config_frame.bg_header_color;
    config.text_header_color =
      properties.chat_tool_properties.config_frame.text_header_color;
    config.background_color_sup =
      properties.chat_tool_properties.config_frame.bg_chat_color_supporter;
    config.text_color_sup =
      properties.chat_tool_properties.config_frame.txt_message_color_supporter;
    config.background_color_vis =
      properties.chat_tool_properties.config_frame.bg_chat_color_visitor;
    config.text_color_vis =
      properties.chat_tool_properties.config_frame.txt_message_color_visitor;
    config.style_desktop =
      properties.chat_tool_properties.config_frame.style_desktop;
    config.style_mobile =
      properties.chat_tool_properties.config_frame.style_mobile;
    config.require_info_user =
      properties.chat_tool_properties.frame_setting.require_info_user;
    config.frame_name = properties.chat_tool_properties.frame_setting.name;
    config.frame_email = properties.chat_tool_properties.frame_setting.email;
    config.frame_phone =
      properties.chat_tool_properties.frame_setting.phone_number;
    config.notify = properties.chat_tool_properties.frame_setting.notify;
    config.notify_info =
      properties.chat_tool_properties.frame_setting.notify_info;
    config.isShowDropDownSelectPage =
      properties.chat_tool_properties.frame_setting.isShowDropDownSelectPage;
    config.max_file_number =
      properties.chat_tool_properties.config_system.max_file_number;
    config.max_one_file_value =
      properties.chat_tool_properties.config_system.max_one_file_value;
    config.disable_review_chat =
      properties.chat_tool_properties.notify_frame.disable_review_chat;
    config.disable_sticker =
      properties.chat_tool_properties.notify_frame.disable_sticker;
    config.disable_upload =
      properties.chat_tool_properties.notify_frame.disable_upload;
    config.bell_notifi = !properties.chat_tool_properties.notify_frame
      .disable_bell_notifi;
    config.name_website = response.name_site;
    config.chat_box_position =
      properties.widget_properties.config_frame.chat_box_position;
    config.widget_config = properties.widget_properties.config_frame;
    config.widget_setting = properties.widget_properties.greeting_setting;
    if (
      properties.widget_properties.config_frame.range_below ||
      properties.widget_properties.config_frame.range_below === 0
    ) {
      config.range_below =
        properties.widget_properties.config_frame.range_below;
    } else {
      config.range_below = 16;
    }
    if (
      properties.widget_properties.config_frame.range_vertical ||
      properties.widget_properties.config_frame.range_vertical === 0
    ) {
      config.range_vertical =
        properties.widget_properties.config_frame.range_vertical;
    } else {
      config.range_vertical = 16;
    }
    if (
      properties.widget_properties.config_frame.size_icon ||
      properties.widget_properties.config_frame.size_icon === 0
    ) {
      config.size_icon = properties.widget_properties.config_frame.size_icon;
    } else {
      config.size_icon = 60;
    }
    config.pageID = properties.connection_config.facebook;

    config.messenger_config = properties.messenger_properties.config_frame;
    config.messenger_setting = properties.messenger_properties.greeting_setting;
    config.team = [];
    config.teamID = '';
  }
}
export default new Tools();
